import React, {useContext, useEffect, useMemo, useState} from "react";
import LargeUserHomepageProductCard from "./types/large";
import {UserHomepageProductContext} from "../../../../index";
import MediumUserWebHomepageProductCard from "./types/medium";
import SmallUserWebHomepageProductCard from "./types/small";
import {UserHomepageProductTypes} from "../../../../models";

const UserWebHomepageProductCard = ({
                                        data: dataProps,
                                        type,
                                        fullWidth = false,
                                        isChildOfCarousel = false,
                                        onProductClicked: onProductClickedProps,
                                        onTagClicked: onTagClickedProps,
                                    }) => {
    const {enforcedHeight = null} = useContext(UserHomepageProductContext);
    const [data, setData] = useState({});

    /**
     * Listens to the changes in data and with each change:
     * - fills in the state information based on the data and whether its oldVersion or not.
     */
    useEffect(() => {
        setData({
            ...dataProps,
            id: dataProps?.id ?? dataProps.Id ?? dataProps.PartId ?? dataProps?.coverImageURL ?? 0,
            imageUrl: dataProps.cover?.url ?? dataProps.coverImage?.url ?? dataProps?.ImageUrl ?? dataProps?.coverImageURL ?? '',
            partNumber: dataProps?.partNumber ?? dataProps?.PartNumber ?? dataProps?.partNo ?? '',
            codeList: dataProps?.codeList ?? dataProps?.CodeList ?? [],
            originalPrice: dataProps?.originalPrice ?? dataProps?.OriginalPrice ?? 0,
            changedPrice: dataProps?.price ?? dataProps?.changedPrice ?? dataProps?.originalPrice ?? dataProps?.ChangedPrice ?? dataProps?.OriginalPrice ?? 0,
            saved: dataProps?.IsSaved ?? dataProps?.isSaved ?? false,
            isCompared: dataProps?.IsInCompareList ?? dataProps?.isInCompareList ?? dataProps?.isInCompare ?? false,
            category: dataProps?.category ?? dataProps?.Category,
            saving: false,
            comparing: false,
            tags: dataProps?.tags ?? [],
        });
    }, [dataProps]);

    /**
     * Calls the onTagClickedProps callback with the current product and the given tag as its arguments.
     * @param {any} tag
     */
    const onTagClicked = (tag) => onTagClickedProps(data, tag);

    /**
     * Calls the onProductClicked callback with the current product as its argument.
     */
    const onProductClicked = () => onProductClickedProps(data);

    /**
     * Renders the appropriate product based on the given type.
     * @type {JSX.Element}
     */
    const product = useMemo(() => {
        switch (type) {
            case UserHomepageProductTypes.large:
                return <LargeUserHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            case UserHomepageProductTypes.medium:
                return <MediumUserWebHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            case UserHomepageProductTypes.small:
                return <SmallUserWebHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            default:
                return <></>
        }
    }, [type, data, onProductClicked, onTagClicked])

    if (isChildOfCarousel) {
        return (
            <div
                className={'product-container'}
                style={{
                    ...(enforcedHeight
                            ? {height: `${enforcedHeight}px`}
                            : {}
                    ),
                }}
            >
                {product}
            </div>
        );
    }

    if (fullWidth) {
        return (
            <div className={'user-web-homepage-product-grid-item'}>
                {product}
            </div>
        );
    }

    return product;
}


export default UserWebHomepageProductCard;
